<div class="aow-shell" [class.aow-shell--decision]="isOnDecisionPage()">
  <!-- Sidebar: full-height, reaches top of screen (hidden on decision page) -->
  <aside class="left" *ngIf="!isOnDecisionPage()">
    <div class="card">
      <div class="back-button">
        <mat-icon matTooltip="Back to client selection" class="back-button__icon" (click)="redirectSelectClient()">arrow_back</mat-icon>
      </div>
      <div class="sidebar-header">
        <img class="logo logo-light" src="assets/images/fraud_deflect_horizontal.png" alt="Fraud Deflect">
        <img class="logo logo-dark" src="assets/images/Fraud_Deflect_logo2-removebg.png" alt="Fraud Deflect">
      </div>

      @if(merchants.length > 1) {
      <div class="sidebar-content">
        <div class="select-merchant-container">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Merchant</mat-label>
            <mat-select [formControl]="merchantControl" placeholder="Select Merchant"
              (selectionChange)="setMerchantOnboardingId($event.value.toString())">
              <mat-option *ngFor="let merchant of merchants" [value]="merchant.id">
                <span class="merchant-option-text">{{ merchant.name }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      }
      <!-- Custom vertical stepper -->
      <nav class="stepper" *ngIf="steps().length > 0">
        <div class="stepper__step" *ngFor="let s of steps(); let i = index; let last = last"
          [class.stepper__step--active]="s.step === activeKey()"
          [class.stepper__step--completed]="s.status === 'completed'" (click)="goTo(s.step)">

          <!-- Circle + track column -->
          <div class="stepper__rail">
            <div class="stepper__circle"
              [class.stepper__circle--active]="s.step === activeKey() || s.status === 'inProgress'"
              [class.stepper__circle--completed]="s.status === 'completed'">
            </div>
            <div class="stepper__track" *ngIf="!last"
              [class.stepper__track--active]="s.step === activeKey() || s.status === 'inProgress'"
              [class.stepper__track--completed]="s.status === 'completed'">
            </div>
          </div>

          <!-- Labels + chip -->
          <div class="stepper__content">
            <div class="stepper__title">{{ labels()[s.step].title }}</div>
            <div class="stepper__subtitle" *ngIf="labels()[s.step].subtitle">
              {{ labels()[s.step].subtitle }}
            </div>
            <div class="stepper__chip" [class.stepper__chip--inprogress]="s.status === 'inProgress'"
              [class.stepper__chip--completed]="s.status === 'completed'"
              [class.stepper__chip--pending]="s.status === 'pending'">
              {{ statusText[s.status] }}
            </div>
          </div>
        </div>
      </nav>
    </div>
  </aside>

  <!-- Right column: header on top, content below -->
  <div class="right-column">
    <app-aow-header></app-aow-header>
    <main class="right">
      <div class="content">
        <mat-card *ngIf="showDemoAlert() && utilities.isDemoOnbValue" class="demo-alert sticky" appearance="outlined"
          role="status" aria-live="polite">
          <button mat-icon-button class="demo-alert__close" aria-label="Close demo notice" (click)="hideDemoAlert()">
            <mat-icon>close</mat-icon>
          </button>
          <div class="demo-alert__body">
            <mat-icon class="demo-alert__icon" aria-hidden="true">warning_amber</mat-icon>
            <div class="demo-alert__text">
              <div class="demo-alert__title">Demo Environment</div>
              <div class="demo-alert__desc">
                Actions and data here are temporary and will be discarded after the session.
              </div>
            </div>
          </div>
        </mat-card>
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>